<template>
    <div class="brand-container">
        <img v-if="customer.brandLogo" class="brand-image" :src="$config.imageUri(customer.brandLogo, 'logo')" />
            <div class="brand-info">
                <label for="">Parceiro</label>
                <p class="brand-name">{{ customer.brandName }}</p>  
            </div>
    </div>
</template>
<script>
export default {
    props: {
        customer: {
            type: Object,
            required: true
        },
    },
}
</script>
<style scoped>
    p {
        margin: 0;
    }

    .brand-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 15px;
        border-radius: 5px;
        background-color: var(--white-color);
        gap: 10px;
        flex: 1;
        line-height: 1.2;
    }

    .brand-image {
        height: 50px;
    }

    .brand-info {
        display: flex;
        flex-direction: column;
    }

    .brand-name {
        font-size: 22px;
        font-weight: bold;
        color: var(--primary-color);
    }
</style>


// WEBPACK FOOTER //
// src/components/Prospection/Cards/BrandCard.vue